const selectors = {
  FORM: '[data-js-form]',
  FORM_ELEMENT: '[data-js-form-element]',
  FORM_INPUT: '[data-js-form-input]'
};

const stateClasses = {
  SUCCESS_CLASS: 'is-success',
  ERROR_CLASS: 'is-error'
}

const validateInput = (input, eventType = '') => {
  const formElem = input.closest(selectors.FORM_ELEMENT);
  let isValid = true;

  if ('checkValidity' in input) {
    isValid = input.checkValidity();
  }

  const isInvalid = event === 'input' ? false : !isValid;

  formElem.classList.toggle(stateClasses.SUCCESS_CLASS, isValid);
  formElem.classList.toggle(stateClasses.ERROR_CLASS, isInvalid);
}

const addFormValidation = (form) => {
  const inputs = Array.from(form.querySelectorAll(selectors.FORM_INPUT));

  form.setAttribute('novalidate', true);

  form.addEventListener('submit', (e) => {
    inputs.forEach((input) => {
      validateInput(input);
    });

    const invalidFormElLength = inputs.filter(i => {
      return i.closest(selectors.FORM_ELEMENT).classList.contains(stateClasses.ERROR_CLASS);
    }).length;

    if(!!invalidFormElLength) {
      e.preventDefault();
    }
  }, false);

  form.addEventListener('blur', (e) => {
    if (inputs.includes(e.target)) {
      validateInput(e.target, e.type);
    }
  }, true);
}

export default () => {
  Array.from(document.querySelectorAll(selectors.FORM)).forEach(addFormValidation);
};
